import { Badge } from '@/components/ui/badge';
import { Card, CardContent } from '@/components/ui/card';
import { TrendingUp, Award } from 'lucide-react';

const getTierConfig = (tier) => {
  const configs = {
    'excellent': {
      label: 'Excellent',
      color: 'hsl(var(--tier-excellent))',
      bgClass: 'bg-gradient-to-br from-purple-50 to-purple-100 dark:from-purple-950/30 dark:to-purple-900/30',
      borderClass: 'border-purple-300 dark:border-purple-700',
      icon: '💎'
    },
    'diamond': {
      label: 'Diamond',
      color: 'hsl(var(--tier-diamond))',
      bgClass: 'bg-gradient-to-br from-cyan-50 to-blue-100 dark:from-cyan-950/30 dark:to-blue-900/30',
      borderClass: 'border-cyan-300 dark:border-cyan-700',
      icon: '💎'
    },
    'platinum': {
      label: 'Platinum',
      color: 'hsl(var(--tier-platinum))',
      bgClass: 'bg-gradient-to-br from-slate-50 to-gray-100 dark:from-slate-950/30 dark:to-gray-900/30',
      borderClass: 'border-slate-300 dark:border-slate-700',
      icon: '⭐'
    },
    'gold': {
      label: 'Gold',
      color: 'hsl(var(--tier-gold))',
      bgClass: 'bg-gradient-to-br from-yellow-50 to-amber-100 dark:from-yellow-950/30 dark:to-amber-900/30',
      borderClass: 'border-yellow-300 dark:border-yellow-700',
      icon: '🏆'
    },
    'silver': {
      label: 'Silver',
      color: 'hsl(var(--tier-silver))',
      bgClass: 'bg-gradient-to-br from-gray-50 to-slate-100 dark:from-gray-950/30 dark:to-slate-900/30',
      borderClass: 'border-gray-300 dark:border-gray-700',
      icon: '🥈'
    },
    'bronze': {
      label: 'Bronze',
      color: 'hsl(var(--tier-bronze))',
      bgClass: 'bg-gradient-to-br from-orange-50 to-amber-100 dark:from-orange-950/30 dark:to-amber-900/30',
      borderClass: 'border-orange-300 dark:border-orange-700',
      icon: '🥉'
    },
    'good': {
      label: 'Good',
      color: 'hsl(142, 76%, 36%)',
      bgClass: 'bg-gradient-to-br from-green-50 to-emerald-100 dark:from-green-950/30 dark:to-emerald-900/30',
      borderClass: 'border-green-300 dark:border-green-700',
      icon: '✅'
    },
    'poor': {
      label: 'Poor',
      color: 'hsl(0, 84%, 60%)',
      bgClass: 'bg-gradient-to-br from-red-50 to-rose-100 dark:from-red-950/30 dark:to-rose-900/30',
      borderClass: 'border-red-300 dark:border-red-700',
      icon: '⚠️'
    }
  };
  
  return configs[tier?.toLowerCase()] || configs['bronze'];
};

export const HotelTierBadge = ({ tierData, hotelName }) => {
  if (!tierData) return null;
  
  const config = getTierConfig(tierData.tier);
  
  return (
    <Card className={`${config.bgClass} ${config.borderClass} border-2`} data-testid="hotel-tier-badge">
      <CardContent className="p-6">
        <div className="flex items-start justify-between">
          <div className="flex-1">
            <div className="flex items-center gap-2 mb-2">
              <Award className="h-5 w-5" style={{ color: config.color }} />
              <h3 className="text-lg font-semibold heading-font">{hotelName}</h3>
            </div>
            <div className="flex items-center gap-3 mb-3">
              <span className="text-3xl">{config.icon}</span>
              <div>
                <Badge 
                  className="text-lg px-3 py-1"
                  style={{ 
                    backgroundColor: config.color,
                    color: 'white'
                  }}
                >
                  {config.label} Tier
                </Badge>
              </div>
            </div>
            <div className="grid grid-cols-3 gap-4 mt-4">
              <div>
                <p className="text-xs text-muted-foreground mb-1">Quality Score</p>
                <p className="text-xl font-bold tabular-nums">{tierData.quality_score || 0}</p>
              </div>
              <div>
                <p className="text-xs text-muted-foreground mb-1">Value Score</p>
                <p className="text-xl font-bold tabular-nums">{tierData.value_score || 0}</p>
              </div>
              <div>
                <p className="text-xs text-muted-foreground mb-1">Final Score</p>
                <p className="text-xl font-bold tabular-nums flex items-center gap-1">
                  {tierData.final_score || 0}
                  <TrendingUp className="h-4 w-4 text-green-600" />
                </p>
              </div>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default HotelTierBadge;
